export const minisiteTabs = {
    billingHub: {
        url: 'billing-hub',
        label: 'Billing Hub',
        supportsSample: false
    },
    agreement: {
        url: 'agreement',
        label: 'Agreement',
        supportsSample: true
    },
    paymentMethods: {
        url: 'payment-methods',
        label: 'Payment Methods',
        supportsSample: false
    },
    invoices: {
        url: 'invoices',
        label: 'Invoices',
        supportsSample: false
    },
    activity: {
        url: 'activity',
        label: 'Activity Log',
        supportsSample: false
    }
};
